/**
 * The Firestore TMS_ORDERS patch for a manually-repositioned stop. Writes ONLY
 * the geocode lat/long (order's `fields.Latitude` / `fields.Longitude`); never
 * any other order field. The persistStopGeocode thunk uses this shape.
 */
export function buildGeocodeFirestoreFields(lat: number, long: number): Record<string, number> {
  return { 'fields.Latitude': lat, 'fields.Longitude': long }
}
